import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ArrowRight, MessageCircle } from 'lucide-react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__main">
        <div className="container footer__grid">
          <div className="footer__brand">
            <div className="footer__logo">
              <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Yashraj Traders India" className="footer__logo-img"/>
              <div>
                <div className="footer__name">Yashraj Traders</div>
                <div className="footer__sub">India · Import · Export</div>
              </div>
            </div>
            <p className="footer__desc">A GST-registered Pune-based trading company delivering premium food products, textiles and handcrafted goods across India and beyond. Founded by Rhutuja B.</p>
            <div className="footer__socials">
              {['in','𝕏','f'].map((s,i)=><a key={i} href="#" className="footer__social">{s}</a>)}
            </div>
            <div className="footer__badges"><span>GSTIN Registered</span><span>Pune, MH</span><span>🇮🇳 India</span></div>
          </div>
          <div className="footer__col">
            <div className="footer__col-head">Navigate</div>
            <ul>{[['/', 'Home'],['/about','About Us'],['/products','Products'],['/global-reach','Our Reach'],['/contact','Contact Us']].map(([to,l])=>(
              <li key={to}><Link to={to} className="footer__lnk"><ArrowRight size={11}/>{l}</Link></li>
            ))}</ul>
          </div>
          <div className="footer__col">
            <div className="footer__col-head">Products</div>
            <ul>{['Roasted Channa','Turmeric Channa','Indian Raw Spices','Kolhapuri Masala','Nagari Black Masala','Organic Jaggery','Atta (All Types)','Cotton Fabric & Yarn','Silk Saree','Paithani Saree','Resin Art Handicrafts'].map(p=>(
              <li key={p}><span className="footer__lnk"><ArrowRight size={11}/>{p}</span></li>
            ))}</ul>
          </div>
          <div className="footer__col">
            <div className="footer__col-head">Contact</div>
            <ul className="footer__contacts">
              <li><MapPin size={13}/><span>Pune, Maharashtra — 411001, India</span></li>
              <li><Phone size={13}/><a href="tel:+917775892822">+91 77758 92822</a></li>
              <li><Phone size={13}/><a href="tel:+918087884319">+91 80878 84319</a></li>
              <li><MessageCircle size={13}/><a href="https://wa.me/919226318469" target="_blank" rel="noreferrer">+91 92263 18469 (WhatsApp)</a></li>
              <li><Mail size={13}/><a href="mailto:yashrajtradersindia11@gmail.com">yashrajtradersindia11@gmail.com</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer__bar">
        <div className="container footer__bar-inner">
          <span>© 2025 Yashraj Traders India. All rights reserved.</span>
          <span>GSTIN: 27CBFPB6539R1Z2 · Founder: Rhutuja B.</span>
        </div>
      </div>
    </footer>
  );
}
